/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, centerAbsolutely, boxShadow } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REWARD STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	reward: {
		display: 'inline-block',
		verticalAlign: 'middle',
		position: 'relative',
        lineHeight: '1.2',

		// ..... REWARD NUMBER ICON ..... //
		'& .rewardnum': {
			background: color.rewards,
			borderRadius: '50%',
			border: `${pxToEm(1)} solid ${color.white}`,
			width: pxToEm(18),
			height: pxToEm(18),
			transition: 'background .2s linear 0s',
			textAlign: 'center',
			position: 'absolute',
			top: pxToEm(-9),
			right: pxToEm(-9),
			zIndex: '2',
			extend: boxShadow.greyLarge,
			opacity: '0',

			'& .number': {
				color: color.white,
				fontSize: pxToEm(12),
				extend: centerAbsolutely
			}
		},

		// ..... GIFT CARD REWARD ..... //
		'& .giftcard': {
			width: `${pxToEm(49)} !important`, //62
			height: `${pxToEm(31)} !important`, //39
			position: 'relative',
			zIndex: '1',
		},

        // ..... REWARD AVAILABLE ..... //
        '&.rewardAvailable-true': {
            '& .rewardnum': {
                opacity: '1'
            },
        },

		// ..... REWARD EARNED ..... //
		'&.rewardAvailable-initial': {
			'& .rewardnum': {
				animationName: 'rollIn',
	            animationDelay: '0.5s',
	            animationDuration: '.5s',
	            animationFillMode: 'forwards',
			},
			'& .giftcard': {
				animationName: 'pulse',
	            animationDelay: '0.7s',
	            animationDuration: '.5s'
			}
		},

        // ..... REWARD UPDATED ..... //
        '&.rewardAvailable-updated': {
            '& .rewardnum': {
                animationName: 'tada',
                animationDelay: '1.2s',
                animationDuration: '.3s',
                animationFillMode: 'forwards',
                opacity: '1'
            },
            '& .giftcard': {
                animationName: 'pulse',
                animationDelay: '0.7s',
                animationDuration: '.5s'
            }
        }
	}
};